import {
  Button,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
  User,
} from "@heroui/react";
import { Lens } from "@/components/ui/lens.tsx";

type Props = {
  data: any;
};

const AnimalModal = ({ data }: Props) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <div onClick={onOpen}>
        <User
          avatarProps={{
            size: "sm",
            isBordered: true,
            src: `${data.image || data.imageUrls?.[0]}`,
          }}
          name={data.name}
          onClick={onOpen}
        />
      </div>

      <Modal
        isDismissable={true}
        isOpen={isOpen}
        size="xl"
        onOpenChange={onOpenChange}
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">
                Animal Image
              </ModalHeader>
              <ModalBody>
                <Lens>
                  <Image
                    alt="NextUI Album Cover"
                    className=""
                    loading={"lazy"}
                    src={data.image || data.imageUrls?.[0]}
                    width={500}
                  />
                </Lens>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default AnimalModal;
